var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCameraAdd = function SvgCameraAdd(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M0 0L16.56 0 16.56 15.12 0 15.12z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#717F97",
    d: "M7.056 9.36c0 1.274 1.03 2.304 2.304 2.304 1.274 0 2.304-1.03 2.304-2.304 0-1.274-1.03-2.304-2.304-2.304-1.275 0-2.304 1.03-2.304 2.304zm2.304 3.6c1.987 0 3.6-1.613 3.6-3.6s-1.613-3.6-3.6-3.6-3.6 1.613-3.6 3.6 1.613 3.6 3.6 3.6zM4.32 6.48V4.32h2.16V2.16h5.04l1.317 1.44h2.283c.792 0 1.44.648 1.44 1.44v8.64c0 .792-.648 1.44-1.44 1.44H3.6c-.792 0-1.44-.648-1.44-1.44v-7.2h2.16zM2.16 2.16V0H3.6v2.16h2.16V3.6H3.6v2.16H2.16V3.6H0V2.16h2.16z",
    mask: "url(#prefix__b)"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCameraAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/camera_add.4ad52a23.svg";
export { ForwardRef as ReactComponent };